var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LevelSeting"},[_c('div',{staticClass:"right"},[(_vm.currentNav == 1)?_c('leveData'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }